var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"goalmobile",staticClass:"mortgage-calcnew__goalmobile"},[_c('d-select',{attrs:{"items":[
			{'const': 'buy', title: 'Покупка'},
			{'const': 'refin', title: 'Рефинансирование'},
			{'const': 'pledge', title: 'Под залог'},
		]},model:{value:(_vm.goalmobile),callback:function ($$v) {_vm.goalmobile=$$v},expression:"goalmobile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }